export const SET_CAROUSEL_POSITION = 'SET_CAROUSEL_POSITION'
